import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import { tokens, Text } from '@hotjar/hotsauce';
import { AccordionSection } from '../PanelAccordion/AccordionSection';
import { Indicator } from '../../EngagementMarkersLayer/EngagementMarker';

const SCORES = [
  {
    level: 'smart-panel.engagement-zones.help.scores.level-1',
    level_indicator: 'smart-panel.engagement-zones.help.scores.moderate',
    color: 'rgba(255, 216,204, 0.5)',
    description: 'smart-panel.engagement-zones.help.scores.moderate-info',
  },
  {
    level: 'smart-panel.engagement-zones.help.scores.level-2',
    level_indicator: 'smart-panel.engagement-zones.help.scores.high',
    color: 'rgba(255, 60, 0, 0.5)',
    description: 'smart-panel.engagement-zones.help.scores.high-info',
  },
  {
    level: 'smart-panel.engagement-zones.help.scores.level-3',
    level_indicator: 'smart-panel.engagement-zones.help.scores.very-high',
    color: 'rgba(179, 42, 0, 0.7)',
    description: 'smart-panel.engagement-zones.help.scores.very-high-info',
  },
];

const Scores = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacer.x3};
`;

const LevelTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LevelIndicator = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${tokens.spacer.x1};
`;

export const ScoreInfoSection = (): JSX.Element => {
  const { t } = useTranslation('heatmaps');

  return (
    <AccordionSection
      title={
        <Text as="span" textType="subtitle2">
          {t('smart-panel.engagement-zones.help.scores.title')}
        </Text>
      }
      headerCustomCss={css`
        padding: ${tokens.spacer.x3};
      `}
    >
      <Scores>
        {SCORES.map((score) => (
          <div>
            <LevelTitle>
              <LevelIndicator>
                <Indicator color={score.color} />
                <Text as="span" textType="subtitle2">
                  {t(score.level_indicator)}
                </Text>
              </LevelIndicator>
              <Text as="span" textType="subtitle2">
                {t(score.level)}
              </Text>
            </LevelTitle>
            <Text as="span">{t(score.description)}</Text>
          </div>
        ))}
      </Scores>
    </AccordionSection>
  );
};
